<template>
	<div role="banner" class="hello-bar">
		<div class="banner-content">
			<a href="https://netcorecloud.com/lp/email-benchmark-report-2024/" class="banner-text columns">
				<div class="banner-text-main column is-12">
					<div class="banner-news">
					<span class="banner-text-highlight">Read more</span> Unlock the Latest Insights: Email Benchmark Report 2024 - Grab Your Copy Now! 
					<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/openlink.svg" alt="g2-fall-link" class="openlink">
					</div>
				</div>
			</a>
		</div>
			<div class="banner-action-btn">
				<a href="#" class="banner-text columns">
					SUPPORT
				</a>
				<a href="#" class="banner-text columns">
					LOG IN
				</a>
			</div>
	</div>
</template>

<script>
	export default {
		name: 'HelloBar'
	}
</script>

<style type="text/css" scoped="">
	.banner-text-highlight{
		background-color: #fc5e02;
		border-radius: 5px;
		padding: 4px 10px;
		font-style: normal;
		font-weight: 500;
		font-size: 14px;
		margin-bottom: 2px;
		margin-right: 10px;
	}

	.banner-text {
		text-decoration: none;
		color: inherit;
	}

	.banner-content {
		overflow: visible;
		width: 100%;
    text-align: center;
	}
	.banner-content .banner-text {
		margin-bottom: 0;
		margin-top: 0;
	}

	.banner-action-btn {
		display: flex;
    align-items: center;
    justify-content: center;
    width: 18%;
		font-size: 14px;
		font-weight: 400;
	}
	.banner-action-btn a {
		margin-bottom: 0;
		margin-top: 0;
	}
	.banner-action-btn a:first-child {
		margin-right: 30px;
	}

	.banner-news {
		vertical-align: middle;
		display: inline;
		font-size: 16px;
		font-weight: 500;
	}

	.hello-bar {
		width: 100%;
		position: relative;
		background-color: #291e30;;
		height: 50px;
		display: flex;
		flex-direction: row;
		justify-content: center;
		color: #fff;
		align-items: center;
		font-weight: 400;
		font-size: 16px;
	}

	.openlink {
	    margin: 0 5px;
	}
@media screen and (max-width: 767px ) {
  .banner-news {
    font-weight: 500;
    font-size: 12px;
	display: flex;
    align-items: center;
  }
  .banner-action-btn {
	display: none;
  }
  .section-list-checkbox {
	display: none;
  }
}
</style>